export const MAX_CONTENT_WIDTH = 492;
export const MAX_SHARED_CARD_CONTENT_WIDTH = 452;
export const SHOW_SIMPLE_SHARED_CARD_CONTENT_WIDTH = 552;
